import * as C from '../Constants'
const ResourceData = (state={}, action) => {
   
    switch(action.type){
        case C.SEARCH_RES:
            return{...state, ResLoading: true};
        case C.SEARCH_RES_SUCCESS:
            return{...state,resources : action.resource, ResLoading: false}  
        default:
            return state;  
    }
};
export default ResourceData